export default __webpack_public_path__ + "static/media/screen_3x.856d0296.jpg";